export enum AssetLoaderEvents {
  ADD = "add",
  CHECK_TAGS = "check-tags",
  COMPLETE = "complete",
  PROGRESS = "progress"
}
